export default __webpack_public_path__ + "static/media/musica_loop_01.1bf56b64.mp3";